import { ref, computed } from 'vue';

// 引用计数：并发请求叠加，count > 0 时显示 loading
const count = ref(0);
// 当前提示文案
const message = ref('加载中...');
// 派生显示状态
const loading = computed(() => count.value > 0);

/**
 * 显示全局 loading
 * @param {string} [msg] - 自定义提示文案，不传则保留当前文案
 */
export function showLoading(msg) {
    if (msg) message.value = msg;
    count.value++;
}

/**
 * 隐藏全局 loading（引用计数，需与 showLoading 配对调用才真正关闭）
 */
export function hideLoading() {
    if (count.value > 0) count.value--;
    if (count.value === 0) message.value = '加载中...';
}

/**
 * 全局 loading hook
 * @returns {{
 *   count: import('vue').Ref<number>,
 *   message: import('vue').Ref<string>,
 *   loading: import('vue').ComputedRef<boolean>,
 *   showLoading: (msg?: string) => void,
 *   hideLoading: () => void
 * }}
 */
export function useLoading() {
    return { count, message, loading, showLoading, hideLoading };
}
